import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { authFetch } from '../util/api';
import { WorkspaceMember, WorkspaceMembersResponse } from './workspace';

export function useWorkspaceMembers(workspaceId: string) {
  const { data: workspaceMembersResponse, ...queryResult } = useQuery({
    queryKey: ['workspace-members', workspaceId],
    queryFn: (): Promise<WorkspaceMembersResponse> =>
      authFetch(`/get_workspace_members?workspaceId=${workspaceId}`),
    enabled: Boolean(workspaceId),
    staleTime: 1000 * 60 * 15,
  });

  const workspaceMembers: WorkspaceMember[] = useMemo(
    () => workspaceMembersResponse?.members || [],
    [workspaceMembersResponse?.members],
  );

  // Convert workspace members array to a map for easier lookup
  const workspaceMembersMap = useMemo(
    () =>
      workspaceMembers.reduce<Record<string, WorkspaceMember>>((acc, member) => {
        acc[member.userId] = member;
        return acc;
      }, {}),
    [workspaceMembers],
  );

  return { workspaceMembers, workspaceMembersMap, ...queryResult };
}
